import { Module } from 'vuex'
import { RootState } from '@/store'
import state, { IPaymentState } from '@/store/payment/state'
import mutations from '@/store/payment/mutations'
import { mutation } from '@/utils/mutation'
import { path } from '@/store/payment/types'

export * from '@/store/payment/state'

export const store: Module<IPaymentState, RootState> = {
  state,
  mutations: mutation(mutations, path)
}
